<mat-card>
    <mat-card-content>
        <div class="pull-right toolbar">
            <button mat-button (click)="copy()">
                <mat-icon>content_copy</mat-icon>
                Copy JSON
            </button>
            <button mat-button (click)="showRaw = !showRaw">
                <mat-icon>{{ showRaw ? "view_agenda" : "data_object" }}</mat-icon>
                {{ showRaw ? "Pretty" : "Raw JSON" }}
            </button>
        </div>

        <div class="meta">
            <span class="level" [ngStyle]="levelStyle">{{ log.level || "—" }}</span>
            <span class="time">{{ time }}</span>
            <span class="chip" *ngIf="log.component">component: {{ log.component }}</span>
            <span class="chip" *ngIf="log.host">host: {{ log.host }}</span>
            <span class="chip" *ngIf="log.environment">env: {{ log.environment }}</span>
            <span class="chip" *ngIf="log.run_id">run: {{ log.run_id }}</span>
        </div>

        <ng-container *ngIf="!showRaw; else rawView">
            <div class="flex row align-center" *ngIf="log.message">
                <h3 class="margin-right-20">Message</h3>
                <div class="message">{{ log.message }}</div>
            </div>

            <ng-container *ngIf="hasContext">
                <h3>Context</h3>
                <div class="tree">
                    <ng-container *ngTemplateOutlet="node; context: {$implicit: log.context, keyName: 'context'}">
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #rawView>
            <pre class="raw" [textContent]="rawJson"></pre>
        </ng-template>
    </mat-card-content>
</mat-card>

<!-- Recursive renderer for objects / arrays / scalars -->
<ng-template #node let-value let-keyName="keyName">
    <ng-container [ngSwitch]="typeOf(value)">
        <table *ngSwitchCase="'object'" class="kv">
            <tr *ngFor="let entry of entries(value)">
                <td class="k">{{keyName}}.{{ entry.key }}</td>
                <td class="v">
                    <ng-container *ngTemplateOutlet="node; context: {$implicit: entry.value}">
                    </ng-container>
                </td>
            </tr>
        </table>
        <ol *ngSwitchCase="'array'" class="arr">
            <li *ngFor="let item of value">
                <ng-container *ngTemplateOutlet="node; context: {$implicit: item}">
                </ng-container>
            </li>
        </ol>
        <span *ngSwitchDefault class="scalar" [class.empty]="value === null">{{ display(value) }}</span>
    </ng-container>
</ng-template>